// extracted by mini-css-extract-plugin
module.exports = {"footer":"FitnessCard_footer__9j_cx"};